import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import IconPicker from '../../../Components/IconPicker'
import { capabilitySchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, capability }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${capability.name}`}
    >
      <BackLink href="/manage/capabilities">Back to Amenities</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={capabilitySchema}
          resource="capability"
          endpoint={`/manage/capabilities/${capability.id}`}
          method="patch"
          backLink="/manage/capabilities"
          submitLabel="Save Changes"
          defaultValues={{
            name: capability.name || '',
            icon: capability.icon || '',
            description: capability.description || '',
            active: capability.active ?? true
          }}
        >
          {({ control, errors, setValue, watch }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <div className="py-3">
                <label className="block text-sm font-medium text-gray-700 mb-2">Icon</label>
                <IconPicker
                  value={watch('icon')}
                  onChange={(val) => setValue('icon', val, { shouldDirty: true })}
                />
              </div>

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                hint="Uncheck to hide this amenity from venues"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
